import React, { useRef, useState } from "react";
import { CircularIndeterminate, FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHDepartamentoIns } from "services/services-mia/RNHDepartamentoIns";

export default function InsertModal({ updateList, closeModal }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);
    const formikRef = useRef();

    const handleCreateZona = async (values) => {
        const response = await RNHDepartamentoIns(
            credentials,
            { 
                name: values.nombre, 
                cod: values.cod,
                desc: values.desc
            }
        );
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Departamento creado correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        }
    }
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: "",
                cod: "",
                desc: ""
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(45, "Debe tener menos de 45 caracteres").required("Debe ingresar un nombre"),
                    cod: yup.string("Debe ingresar un código").max(20, "Debe tener menos de 20 caracteres").required("Debe ingresar un código"),
                    desc: yup.string("Debe ingresar una descripción").max(150, "Debe tener menos de 150 caracteres").required("Debe ingresar una descripción"),
                })
            }
            onSubmit={(values) => {
                handleCreateZona(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <>
                        <FormikTextInput
                            fullWidth={true}
                            name="nombre"
                            placeholder=""
                            labelText="Nombre de departamento"
                        />
                        <FormikTextInput
                            fullWidth={true}
                            name="cod"
                            placeholder=""
                            labelText="Código de departamento"
                        />
                        <FormikTextInput
                            fullWidth={true}
                            name="desc"
                            placeholder=""
                            labelText="Descripción de departamento"
                            multiline
                        />
                    </>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Crear" }}
                        onCloseModal={closeModal}
                    />
                    {(inRequest) && <CircularIndeterminate />}
                </div>
            </Form>
        </Formik>
    );
}
